import { render } from "./FileInput.vue?vue&type=template&id=0a05253f&scoped=true&ts=true"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"

import "./FileInput.vue?vue&type=style&index=0&id=0a05253f&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a05253f"]])

export default __exports__